import { render, staticRenderFns } from "./PayslipView.vue?vue&type=template&id=3d2ecff8&scoped=true&"
import script from "./PayslipView.vue?vue&type=script&lang=js&"
export * from "./PayslipView.vue?vue&type=script&lang=js&"
import style0 from "./PayslipView.vue?vue&type=style&index=0&id=3d2ecff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2ecff8",
  null
  
)

export default component.exports